import { Button } from '../components/button'
import { defineComponent, reactive, Teleport } from 'vue'
import { useStore } from './state'
import { useRouter } from 'vue-router'
import Section from '../components/section'
import { Dialog } from '../components/dialog'

export default defineComponent({
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(2)

    const state = reactive({
      showInvalidPopup: false,
    })

    const goToNext = () => {
      if (store.stageValidity === true) {
        router.push({
          name: 'stage3',
        })
      } else {
        state.showInvalidPopup = true
      }
    }

    return () => [
      <div class="py-20">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        <div class="flex gap-6 items-center mt-16 justify-center px-4">
          <div class="font-bold text-lg">생년월일</div>
          <div class="flex items-center">
            <select
              value={store.birthYear}
              placeholder="연도"
              class="border border-[#dbdbdb] rounded-md px-4 py-2"
              onChange={(e) => {
                store.birthYear = (e.target as HTMLSelectElement).value
              }}
            >
              {new Array(70).fill(0).map((el, idx) => {
                return <option value={idx + 1950}>{idx + 1950}</option>
              })}
            </select>
            <div class="ml-2">년</div>
          </div>
          <div class="flex items-center">
            <select
              value={store.birthMonth}
              placeholder="월"
              class="border border-[#dbdbdb] rounded-md px-4 py-2"
              onChange={(e) => {
                store.birthMonth = (e.target as HTMLSelectElement).value
              }}
            >
              {new Array(12).fill(0).map((el, idx) => {
                return <option value={idx + 1}>{idx + 1}</option>
              })}
            </select>
            <div class="ml-2">월</div>
          </div>
          <div class="flex items-center">
            <select
              value={store.birthDate}
              placeholder="일"
              class="border border-[#dbdbdb] rounded-md px-4 py-2"
              onChange={(e) => {
                store.birthDate = (e.target as HTMLSelectElement).value
              }}
            >
              {new Array(31).fill(0).map((el, idx) => {
                return <option value={idx + 1}>{idx + 1}</option>
              })}
            </select>
            <div class="ml-2">일</div>
          </div>
        </div>
        <Section onlyMobile={true}>
          <Button class="w-full" onClick={goToNext}>
            계속
          </Button>
        </Section>
      </div>,
      <Teleport to="body">
        <Dialog
          visible={state.showInvalidPopup}
          showCloseButton={true}
          closeOnBackdrop={true}
          onClose={() => {
            router.push({
              name: 'main',
            })
          }}
        >
          <div class="p-8 text-center basis-full">
            참여 가능한 대상이 아닙니다
          </div>
        </Dialog>
      </Teleport>,
    ]
  },
})
